

// import React, { useState, useEffect } from "react";
// import {  Upload } from "lucide-react";
// import { IoMdStar } from "react-icons/io";
// import toast from "react-hot-toast";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import SummaryApi from "../common/SummaryApi";
// import api from "../common/apiClient";

// const AddTestimonial = () => {
//   const navigate = useNavigate();
//   const [searchParams] = useSearchParams();

//   const mode = searchParams.get("mode") || "add";
//   const id = searchParams.get("id");

//   const isEdit = mode === "edit";
//   const isView = mode === "view";

//  const [form, setForm] = useState({
//   name: "",
//   location: "",
//   rating: 0,
//   status: "Publish",
//   review: "",
//   photo: "",
// });

//   // Load data when edit/view
//  useEffect(() => {
//   const fetchTestimonial = async () => {
//     try {
//       if (!id) return;

//       const res = await api({
//         url: SummaryApi.getOneTestimonial.url(id),
//         method: SummaryApi.getOneTestimonial.method,
//       });

//       const data = res?.data?.data;
//       if (data) setForm(data);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   fetchTestimonial();
// }, [id]);


//   const handleImageUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const reader = new FileReader();
//     reader.onloadend = () =>
//       setForm((prev) => ({ ...prev, photo: reader.result }));
//     reader.readAsDataURL(file);
//   };

//  const handleSave = async () => {
//   if (!form.name || !form.location) {
//     toast.error("Fill name & location ❌");
//     return;
//   }

//   try {
//     if (isEdit) {
//       // UPDATE
//       await api({
//   url: SummaryApi.updateOneTestimonial.url(id),
//   method: SummaryApi.updateOneTestimonial.method,
//   data: form,
// });

//       toast.success("Updated successfully ✅");
//     } else {
//       // CREATE
//       await api({
//         url: SummaryApi.createTestimonial.url,
//         method: SummaryApi.createTestimonial.method,
//         data: form,
//       });

//       toast.success("Saved successfully ✅");
//     }

//     navigate("/admin-panel/testimonial-list");
//   } catch (error) {
//     console.log(error);
//     toast.error("Something went wrong");
//   }
// };

//   return (
//     <div className="p-2">

//       <h1 className="text-2xl font-semibold mb-6">
//         {isView
//           ? "View Testimonial"
//           : isEdit
//           ? "Edit Testimonial"
//           : "Add Testimonial"}
//       </h1>

//       <div className="grid md:grid-cols-2 gap-4">

//         <div>
//           <label className="text-sm">Client Name</label>
//           <input
//             className="w-full border p-2 rounded mt-1"
//             value={form.name}
//             onChange={(e) =>
//               setForm({ ...form, name: e.target.value })
//             }
//             disabled={isView}
//           />
//         </div>

//         <div>
//           <label className="text-sm">Location</label>
//           <input
//             className="w-full border p-2 rounded mt-1"
//             value={form.location}
//             onChange={(e) =>
//               setForm({ ...form, location: e.target.value })
//             }
//             disabled={isView}
//           />
//         </div>

//         <div>
//           <label className="text-sm">Rating</label>
//           <div className="flex gap-1 mt-1">
//             {[1, 2, 3, 4, 5].map((i) => (
//               <IoMdStar 
//                 key={i}
//                 className={`w-5 h-5 ${
//                   i <= form.rating
//                     ? "text-[#6f8f2f] fill-[#6f8f2f]"
//                     : "text-gray-300"
//                 } ${isView ? "" : "cursor-pointer"}`}
//                 onClick={() =>
//                   !isView && setForm({ ...form, rating: i })
//                 }
//               />
//             ))}
//           </div>
//         </div>

//         <div>
//           <label className="text-sm">Status</label>
//           <select
//             className="w-full border p-2 rounded mt-1"
//             value={form.status}
//             onChange={(e) =>
//               setForm({ ...form, status: e.target.value })
//             }
//             disabled={isView}
//           >
//             <option>Publish</option>
//             <option>Draft</option>
//           </select>
//         </div>

//       </div>

//       <div className="mt-4">
//         <label className="text-sm">Review</label>
//         <textarea
//           className="w-full border p-2 rounded mt-1 h-32"
//           value={form.review}
//           onChange={(e) =>
//             setForm({ ...form, review: e.target.value })
//           }
//           disabled={isView}
//         />
//       </div>

//       <div className="mt-4">
//         <label className="text-sm">Photo</label>

//         {!isView && (
//           <div className="border-2 border-dashed rounded-md h-[120px] flex flex-col items-center justify-center text-gray-400 bg-[#F6F6F6] mt-1 relative cursor-pointer">
//             <Upload />
//             <p className="text-xs">Click to upload</p>
//             <input
//               type="file"
//               accept="image/*"
//               className="absolute inset-0 opacity-0"
//               onChange={handleImageUpload}
//             />
//           </div>
//         )}

//         {form.photo && (
//           <img
//             src={form.photo}
//             alt="preview"
//             className="mt-2 w-32 h-32 object-cover rounded-md"
//           />
//         )}
//       </div>

//       <div className="flex justify-end gap-3 mt-6">
//         <button
//           className="px-4 py-2 bg-gray-300 rounded"
//           onClick={() => navigate("/admin-panel/testimonial-list")}
//         >
//           Back
//         </button>

//         {!isView && (
//           <button
//             className="px-4 py-2 bg-[#6f8f2f] text-white rounded"
//             onClick={handleSave}
//           >
//             Save
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AddTestimonial;\


// import React, { useState, useEffect } from "react";
// import { Upload } from "lucide-react";
// import { IoMdStar } from "react-icons/io";
// import toast from "react-hot-toast";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import SummaryApi from "../common/SummaryApi";
// import api from "../common/apiClient";

// const AddTestimonial = () => {
//   const navigate = useNavigate();
//   const [searchParams] = useSearchParams();

//   const mode = searchParams.get("mode") || "add";
//   const id = searchParams.get("id");

//   const isEdit = mode === "edit";
//   const isView = mode === "view";

//   const [form, setForm] = useState({
//     name: "",
//     location: "",
//     rating: 0,
//     status: "Publish",
//     review: "",
//     photo: "",
//     experienceImage: "", // NEW FIELD
//   });

//   useEffect(() => {
//     const fetchTestimonial = async () => {
//       try {
//         if (!id) return;

//         const res = await api({
//           url: SummaryApi.getOneTestimonial.url(id),
//           method: SummaryApi.getOneTestimonial.method,
//         });

//         const data = res?.data?.data;
//         if (data) setForm(data);
//       } catch (error) {
//         console.log(error);
//       }
//     };

//     fetchTestimonial();
//   }, [id]);

//   const handleImageUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const reader = new FileReader();
//     reader.onloadend = () =>
//       setForm((prev) => ({ ...prev, photo: reader.result }));
//     reader.readAsDataURL(file);
//   };

//   // NEW HANDLER
//   const handleExperienceUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const reader = new FileReader();
//     reader.onloadend = () =>
//       setForm((prev) => ({ ...prev, experienceImage: reader.result }));
//     reader.readAsDataURL(file);
//   };

//   const handleSave = async () => {
//     if (!form.name || !form.location) {
//       toast.error("Fill name & location ❌");
//       return;
//     }

//     try {
//       if (isEdit) {
//         await api({
//           url: SummaryApi.updateOneTestimonial.url(id),
//           method: SummaryApi.updateOneTestimonial.method,
//           data: form,
//         });

//         toast.success("Updated successfully ✅");
//       } else {
//         await api({
//           url: SummaryApi.createTestimonial.url,
//           method: SummaryApi.createTestimonial.method,
//           data: form,
//         });

//         toast.success("Saved successfully ✅");
//       }

//       navigate("/admin-panel/testimonial-list");
//     } catch (error) {
//       console.log(error);
//       toast.error("Something went wrong");
//     }
//   };

//   return (
//     <div className="p-2">
//       <h1 className="text-2xl font-semibold mb-6">
//         {isView
//           ? "View Testimonial"
//           : isEdit
//           ? "Edit Testimonial"
//           : "Add Testimonial"}
//       </h1>

//       <div className="grid md:grid-cols-2 gap-4">
//         <div>
//           <label className="text-sm">Client Name</label>
//           <input
//             className="w-full border p-2 rounded mt-1"
//             value={form.name}
//             onChange={(e) =>
//               setForm({ ...form, name: e.target.value })
//             }
//             disabled={isView}
//           />
//         </div>

//         <div>
//           <label className="text-sm">Location</label>
//           <input
//             className="w-full border p-2 rounded mt-1"
//             value={form.location}
//             onChange={(e) =>
//               setForm({ ...form, location: e.target.value })
//             }
//             disabled={isView}
//           />
//         </div>

//         <div>
//           <label className="text-sm">Rating</label>
//           <div className="flex gap-1 mt-1">
//             {[1, 2, 3, 4, 5].map((i) => (
//               <IoMdStar
//                 key={i}
//                 className={`w-5 h-5 ${
//                   i <= form.rating
//                     ? "text-[#6f8f2f] fill-[#6f8f2f]"
//                     : "text-gray-300"
//                 } ${isView ? "" : "cursor-pointer"}`}
//                 onClick={() =>
//                   !isView && setForm({ ...form, rating: i })
//                 }
//               />
//             ))}
//           </div>
//         </div>

//         <div>
//           <label className="text-sm">Status</label>
//           <select
//             className="w-full border p-2 rounded mt-1"
//             value={form.status}
//             onChange={(e) =>
//               setForm({ ...form, status: e.target.value })
//             }
//             disabled={isView}
//           >
//             <option>Publish</option>
//             <option>Draft</option>
//           </select>
//         </div>
//       </div>

//       <div className="mt-4">
//         <label className="text-sm">Review</label>
//         <textarea
//           className="w-full border p-2 rounded mt-1 h-32"
//           value={form.review}
//           onChange={(e) =>
//             setForm({ ...form, review: e.target.value })
//           }
//           disabled={isView}
//         />
//       </div>

//       {/* CLIENT PHOTO */}
//       <div className="mt-4">
//         <label className="text-sm">Client Photo</label>

//         {!isView && (
//           <div className="border-2 border-dashed rounded-md h-[120px] flex flex-col items-center justify-center text-gray-400 bg-[#F6F6F6] mt-1 relative cursor-pointer">
//             <Upload />
//             <p className="text-xs">Click to upload</p>
//             <input
//               type="file"
//               accept="image/*"
//               className="absolute inset-0 opacity-0"
//               onChange={handleImageUpload}
//             />
//           </div>
//         )}

//         {form.photo && (
//           <img
//             src={form.photo}
//             alt="preview"
//             className="mt-2 w-32 h-32 object-cover rounded-md"
//           />
//         )}
//       </div>

//       {/* NEW FIELD */}
//       <div className="mt-4">
//         <label className="text-sm">Client Experience Image</label>

//         {!isView && (
//           <div className="border-2 border-dashed rounded-md h-[120px] flex flex-col items-center justify-center text-gray-400 bg-[#F6F6F6] mt-1 relative cursor-pointer">
//             <Upload />
//             <p className="text-xs">Click to upload</p>
//             <input
//               type="file"
//               accept="image/*"
//               className="absolute inset-0 opacity-0"
//               onChange={handleExperienceUpload}
//             />
//           </div>
//         )}

//         {form.experienceImage && (
//           <img
//             src={form.experienceImage}
//             alt="preview"
//             className="mt-2 w-32 h-32 object-cover rounded-md"
//           />
//         )}
//       </div>

//       <div className="flex justify-end gap-3 mt-6">
//         <button
//           className="px-4 py-2 bg-gray-300 rounded"
//           onClick={() => navigate("/admin-panel/testimonial-list")}
//         >
//           Back
//         </button>

//         {!isView && (
//           <button
//             className="px-4 py-2 bg-[#6f8f2f] text-white rounded"
//             onClick={handleSave}
//           >
//             Save
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AddTestimonial;


// import React, { useState, useEffect } from "react";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import { IoMdStar } from "react-icons/io";
// import { Upload as Camera } from "lucide-react";
// import toast from "react-hot-toast";
// import api from "../common/apiClient";
// import SummaryApi from "../common/SummaryApi";

// const AddTestimonial = () => {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(false);
//   const [searchParams] = useSearchParams();
//   const mode = searchParams.get("mode") || "add";
//   const id = searchParams.get("id");
//   const isEdit = mode === "edit";
//   const isView = mode === "view";

//   const [form, setForm] = useState({
//     name: "",
//     location: "",
//     rating: 0,
//     status: "Publish",
//     review: "",
//     clientImage: null, // File object
//     experienceImages: [null, null], // Two File objects
//   });

//   // Fetch existing testimonial if editing
//   useEffect(() => {
//     const fetchTestimonial = async () => {
//       if (!id) return;
//       try {
//         const res = await api({
//           url: SummaryApi.getOneTestimonial.url(id),
//           method: SummaryApi.getOneTestimonial.method,
//         });
//         const data = res?.data?.data;
//         if (data) {
//           setForm({
//             name: data.name || "",
//             location: data.location || "",
//             rating: data.rating || 0,
//             status: data.status || "Publish",
//             review: data.review || "",
//             clientImage: data.clientImage || null,
//             experienceImages: [
//               data.experienceImage1 || null,
//               data.experienceImage2 || null,
//             ],
//           });
//         }
//       } catch (error) {
//         console.error(error);
//       }
//     };
//     fetchTestimonial();
//   }, [id]);

//   // Upload handler
//   const handleUpload = (key, index = null) => (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     if (index !== null) {
//       const newArr = [...form.experienceImages];
//       newArr[index] = file;
//       setForm((prev) => ({ ...prev, experienceImages: newArr }));
//     } else {
//       setForm((prev) => ({ ...prev, [key]: file }));
//     }
//   };

//   // Save testimonial
//   const handleSave = async () => {
//     if (!form.name || !form.location) {
//       toast.error("Fill name & location ❌");
//       return;
//     }

//     try {
//       const formData = new FormData();
//       formData.append("name", form.name);
//       formData.append("location", form.location);
//       formData.append("rating", form.rating);
//       formData.append("status", form.status);
//       formData.append("review", form.review);

//       if (form.clientImage) formData.append("clientImage", form.clientImage);
//       form.experienceImages.forEach((img, i) => {
//         if (img) formData.append(`experienceImage${i + 1}`, img);
//       });

//       if (isEdit) {
//         await api({
//           url: SummaryApi.updateOneTestimonial.url(id),
//           method: SummaryApi.updateOneTestimonial.method,
//           data: formData,
//         });
//         toast.success("Updated successfully ✅");
//       } else {
//         await api({
//           url: SummaryApi.createTestimonial.url,
//           method: SummaryApi.createTestimonial.method,
//           data: formData,
//         });
//         toast.success("Saved successfully ✅");
//       }

//       navigate("/admin-panel/testimonial-list");
//     } catch (error) {
//       console.error(error);
//       toast.error("Something went wrong");
//     }
//   };

//   // Image preview box
//   const renderImageBox = (imgFile, placeholder, onChange) => {
//     const preview = imgFile
//       ? typeof imgFile === "string"
//         ? imgFile
//         : URL.createObjectURL(imgFile)
//       : "";

//     return (
//       <div className="border-2 border-dashed rounded-lg h-48 flex flex-col items-center justify-center bg-[#F6F6F6] cursor-pointer relative">
//         {preview ? (
//           <img
//             src={preview}
//             alt={placeholder}
//             className="w-full h-full object-cover rounded-lg"
//           />
//         ) : (
//           <div className="flex flex-col items-center text-gray-400">
//             <Camera className="w-8 h-8 mb-1" />
//             <p className="text-xs text-center">{placeholder}</p>
//             <p className="text-xs text-gray-400">(Recommended: 300 x 300px)</p>
//           </div>
//         )}
//         {!isView && (
//           <input
//             type="file"
//             accept="image/*"
//             className="absolute inset-0 opacity-0 cursor-pointer"
//             onChange={onChange}
//           />
//         )}
//       </div>
//     );
//   };

//   return (
//     <div className="p-6">
//       <button
//         onClick={() => navigate("/admin-panel/testimonial-list")}
//         className="text-gray-600 mb-4 flex items-center gap-2"
//       >
//         &larr; Back to Testimonials
//       </button>

//       <h1 className="text-2xl font-semibold mb-6">
//         {isView ? "View Testimonial" : isEdit ? "Edit Testimonial" : "Add New Testimonial"}
//       </h1>

//       <div className="grid md:grid-cols-2 gap-6 mb-6">
//         {/* Left column */}
//         <div className="space-y-4">
//           <div>
//             <label className="text-sm font-medium">Client Full Name</label>
//             <input
//               type="text"
//               value={form.name}
//               onChange={(e) => setForm({ ...form, name: e.target.value })}
//               disabled={isView}
//               className="w-full border p-2 rounded mt-1 bg-gray-50"
//             />
//           </div>

//           <div>
//             <label className="text-sm font-medium">Rating</label>
//             <div className="flex items-center gap-2 mt-1">
//               {[1, 2, 3, 4, 5].map((i) => (
//                 <IoMdStar
//                   key={i}
//                   className={`w-5 h-5 ${
//                     i <= form.rating ? "text-[#6f8f2f]" : "text-gray-300"
//                   } ${isView ? "" : "cursor-pointer"}`}
//                   onClick={() => !isView && setForm({ ...form, rating: i })}
//                 />
//               ))}
//               <span className="text-gray-500 text-sm">({form.rating}/5 Stars)</span>
//             </div>
//           </div>

//           <div>
//             <label className="text-sm font-medium">Publication Status</label>
//             <select
//               value={form.status}
//               onChange={(e) => setForm({ ...form, status: e.target.value })}
//               disabled={isView}
//               className="w-full border p-2 rounded mt-1 bg-gray-50"
//             >
//               <option>Publish</option>
//               <option>Draft</option>
//             </select>
//           </div>
//         </div>

//         {/* Right column */}
//         <div className="space-y-4">
//           <div>
//             <label className="text-sm font-medium">Client Location</label>
//             <input
//               type="text"
//               value={form.location}
//               onChange={(e) => setForm({ ...form, location: e.target.value })}
//               disabled={isView}
//               className="w-full border p-2 rounded mt-1 bg-gray-50"
//             />
//           </div>

//           {renderImageBox(form.clientImage, "Client Image", handleUpload("clientImage"))}

//           <div>
//             <label className="text-sm font-medium">Review Text</label>
//             <textarea
//               value={form.review}
//               onChange={(e) => setForm({ ...form, review: e.target.value })}
//               disabled={isView}
//               className="w-full border p-2 rounded mt-1 h-full bg-gray-50"
//             />
//           </div>
//         </div>
//       </div>

//       {/* Client Experience Images */}
//       <div className="mt-6">
//         <h2 className="text-sm font-semibold mb-2">Client Experience</h2>
//         <div className="grid md:grid-cols-2 gap-4">
//           {form.experienceImages.map((img, idx) =>
//             renderImageBox(img, `Experience Image ${idx + 1}`, handleUpload("experienceImages", idx))
//           )}
//         </div>
//       </div>

//       {/* Action buttons */}
//       <div className="flex justify-end gap-4 mt-6">
//         <button
//           className="px-4 py-2 border rounded"
//           onClick={() => navigate("/admin-panel/testimonial-list")}
//         >
//           Cancel
//         </button>
//         {!isView && (
//           <button
//             className="px-4 py-2 bg-[#45A301] text-white rounded"
//             onClick={handleSave}
//           >
//             Save Testimonial
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AddTestimonial;



import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { IoMdStar } from "react-icons/io";
import { Upload as Camera, Loader2, ChevronLeft } from "lucide-react"; // Added Loader2 and ChevronLeft
import toast from "react-hot-toast";
import api from "../common/apiClient";
import SummaryApi from "../common/SummaryApi";
import PageLoader from "../helpers/PageLoader";

const TestimonialForm = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false); // Used for fetching existing data
  const [isSubmitting, setIsSubmitting] = useState(false); // NEW: Used for Save/Update actions
  const [searchParams] = useSearchParams();
  
  const mode = searchParams.get("mode") || "add";
  const id = searchParams.get("id");
  const isEdit = mode === "edit";
  const isView = mode === "view";

  const [form, setForm] = useState({
    name: "",
    location: "",
    rating: 0,
    status: "Publish",
    review: "",
    clientImage: null, 
    experienceImages: [null, null], 
  });

  // Fetch existing testimonial if editing or viewing
  useEffect(() => {
    const fetchTestimonial = async () => {
      if (!id) return;
      setLoading(true);
      try {
        const res = await api({
          url: SummaryApi.getOneTestimonial.url(id),
          method: SummaryApi.getOneTestimonial.method,
        });
        const data = res?.data?.data;
        if (data) {
          setForm({
            name: data.name || "",
            location: data.location || "",
            rating: data.rating || 0,
            status: data.status || "Publish",
            review: data.review || "",
            clientImage: data.photo?.url || null, // Adjusted to match your data format
            experienceImages: [
              data.clientExperience?.[0]?.url || null,
              data.clientExperience?.[1]?.url || null,
            ],
          });
        }
      } catch (error) {
        console.error(error);
        toast.error("Failed to load testimonial details");
      } finally {
        setLoading(false);
      }
    };
    fetchTestimonial();
  }, [id]);

  // Upload handler
  const handleUpload = (key, index = null) => (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (index !== null) {
      const newArr = [...form.experienceImages];
      newArr[index] = file;
      setForm((prev) => ({ ...prev, experienceImages: newArr }));
    } else {
      setForm((prev) => ({ ...prev, [key]: file }));
    }
  };

  // Save testimonial
  const handleSave = async () => {
    if (!form.name || !form.location) {
      toast.error("Please fill in name & location");
      return;
    }

    setIsSubmitting(true); // Start button loading
    try {
      const formData = new FormData();
      formData.append("name", form.name);
      formData.append("location", form.location);
      formData.append("rating", form.rating);
      formData.append("status", form.status);
      formData.append("review", form.review);

      // Handle file uploads
      if (form.clientImage instanceof File) {
        formData.append("photo", form.clientImage);
      }
      
      // Handle experience images
      form.experienceImages.forEach((img, i) => {
        if (img instanceof File) {
          formData.append("clientExperience", img);
        }
      });

      if (isEdit) {
        await api({
          url: SummaryApi.updateOneTestimonial.url(id),
          method: SummaryApi.updateOneTestimonial.method,
          data: formData,
        });
        toast.success("Testimonial updated successfully ✅");
      } else {
        await api({
          url: SummaryApi.createTestimonial.url,
          method: SummaryApi.createTestimonial.method,
          data: formData,
        });
        toast.success("Testimonial saved successfully ✅");
      }

      navigate("/admin-panel/testimonial-list");
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setIsSubmitting(false); // End button loading
    }
  };

  // Image preview box
  const renderImageBox = (imgFile, placeholder, onChange) => {
    const preview = imgFile
      ? typeof imgFile === "string"
        ? imgFile
        : URL.createObjectURL(imgFile)
      : "";

    return (
      <div className={`border-2 border-dashed rounded-lg h-48 flex flex-col items-center justify-center bg-[#F6F6F6] relative transition-all ${isView ? "" : "hover:border-[#45A301] cursor-pointer"}`}>
        {preview ? (
          <img
            src={preview}
            alt={placeholder}
            className="w-full h-full object-cover rounded-lg"
          />
        ) : (
          <div className="flex flex-col items-center text-gray-400">
            <Camera className="w-8 h-8 mb-1" />
            <p className="text-xs text-center font-medium">{placeholder}</p>
            {!isView && <p className="text-[10px] text-gray-400 mt-1">(Click to upload)</p>}
          </div>
        )}
        {!isView && !isSubmitting && (
          <input
            type="file"
            accept="image/*"
            className="absolute inset-0 opacity-0 cursor-pointer"
            onChange={onChange}
          />
        )}
      </div>
    );
  };

  if (loading) return <PageLoader />;

  return (
    <div>
      <button
        onClick={() => navigate("/admin-panel/testimonial-list")}
        className="text-gray-500 hover:text-gray-800 mb-6 flex items-center gap-2 transition-colors text-sm font-medium"
      >
        <ChevronLeft size={18} /> Back to Testimonials
      </button>

      <div className="flex justify-between items-center mb-8">
        <h1 className="text-2xl md:text-3xl font-serif text-gray-800">
          {isView ? "View Testimonial" : isEdit ? "Edit Testimonial" : "Add New Testimonial"}
        </h1>
      </div>

      <div className="bg-white rounded-2xl border p-6 md:p-8 shadow-sm">
        <div className="grid md:grid-cols-2 gap-8">
          {/* Left column */}
          <div className="space-y-6">
            <div>
              <label className="text-xs font-bold text-gray-500 uppercase tracking-wider">Client Full Name</label>
              <input
                type="text"
                placeholder="Enter client name"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                disabled={isView || isSubmitting}
                className="w-full border p-3 rounded-lg mt-1 outline-none focus:ring-2 ring-gray-100 disabled:bg-gray-50 transition-all"
              />
            </div>

            <div>
              <label className="text-xs font-bold text-gray-500 uppercase tracking-wider">Rating</label>
              <div className="flex items-center gap-2 mt-2">
                {[1, 2, 3, 4, 5].map((i) => (
                  <IoMdStar
                    key={i}
                    className={`w-6 h-6 transition-transform ${
                      i <= form.rating ? "text-[#45A301]" : "text-gray-200"
                    } ${isView || isSubmitting ? "" : "cursor-pointer hover:scale-110"}`}
                    onClick={() => !isView && !isSubmitting && setForm({ ...form, rating: i })}
                  />
                ))}
                <span className="text-gray-400 text-sm ml-2 font-medium">({form.rating}/5 Stars)</span>
              </div>
            </div>

            <div>
              <label className="text-xs font-bold text-gray-500 uppercase tracking-wider">Publication Status</label>
              <select
                value={form.status}
                onChange={(e) => setForm({ ...form, status: e.target.value })}
                disabled={isView || isSubmitting}
                className="w-full border p-3 rounded-lg mt-1 outline-none focus:ring-2 ring-gray-100 disabled:bg-gray-50 transition-all"
              >
                <option value="Publish">Publish</option>
                <option value="Draft">Draft</option>
              </select>
            </div>

            <div>
              <label className="text-xs font-bold text-gray-500 uppercase tracking-wider">Client Location</label>
              <input
                type="text"
                placeholder="e.g. Kochi, Kerala"
                value={form.location}
                onChange={(e) => setForm({ ...form, location: e.target.value })}
                disabled={isView || isSubmitting}
                className="w-full border p-3 rounded-lg mt-1 outline-none focus:ring-2 ring-gray-100 disabled:bg-gray-50 transition-all"
              />
            </div>
          </div>

          {/* Right column */}
          <div className="space-y-6">
            <div>
              <label className="text-xs font-bold text-gray-500 uppercase tracking-wider">Client Image</label>
              <div className="mt-1">
                {renderImageBox(form.clientImage, "Client Profile Picture", handleUpload("clientImage"))}
              </div>
            </div>

            <div>
              <label className="text-xs font-bold text-gray-500 uppercase tracking-wider">Review Text</label>
              <textarea
                placeholder="What did the client say about your service?"
                value={form.review}
                onChange={(e) => setForm({ ...form, review: e.target.value })}
                disabled={isView || isSubmitting}
                className="w-full border p-3 rounded-lg mt-1 h-32 outline-none focus:ring-2 ring-gray-100 disabled:bg-gray-50 transition-all resize-none"
              />
            </div>
          </div>
        </div>

        {/* Client Experience Images */}
        <div className="mt-10 border-t pt-8">
          <h2 className="text-sm font-bold text-gray-800 uppercase tracking-widest mb-4">Client Experience Gallery</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {form.experienceImages.map((img, idx) =>
              renderImageBox(img, `Experience Highlight ${idx + 1}`, handleUpload("experienceImages", idx))
            )}
          </div>
        </div>

        {/* Action buttons */}
        <div className="flex justify-end items-center gap-4 mt-12 pt-6 border-t">
          <button
            disabled={isSubmitting}
            className="px-6 py-2.5 border rounded-lg text-sm font-medium hover:bg-gray-50 disabled:opacity-50 transition-all"
            onClick={() => navigate("/admin-panel/testimonial-list")}
          >
            Cancel
          </button>
          {!isView && (
            <button
              disabled={isSubmitting}
              className="px-8 py-2.5 bg-[#45A301] text-white rounded-lg text-sm font-bold hover:bg-[#3a8a01] disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center gap-2 shadow-md shadow-green-100"
              onClick={handleSave}
            >
              {isSubmitting ? (
                <>
                  <Loader2 className="animate-spin" size={18} />
                  {isEdit ? "Updating..." : "Saving..."}
                </>
              ) : (
                isEdit ? "Update Testimonial" : "Save Testimonial"
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TestimonialForm;